import React, { useState } from 'react';
import styled from 'styled-components';
import { capitalize } from 'lodash';

const Modal = styled.div.attrs({
  className: 'modal',
})`
  transition: all 0.5s ease;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  display: block;
  visibility: hidden;

  &.visible {
    opacity: 1;
    visibility: visible;
  }
`;

const ModalBody = styled.div.attrs({
  className: 'modal-body',
})`
  max-height: 30rem;
  overflow: auto;
`;

function renderDialogFooter(type, setVisible, onOk) {
  if (type === 'confirm') {
    return (
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-light"
          onClick={() => setVisible(false)}
        >
                Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onOk}
        >
                OK
        </button>
      </div>
    );
  } if (type === 'alert') {
    return (
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => setVisible(false)}
        >
                OK
        </button>
      </div>
    );
  }
  return null;
}

export default function useDialog({
  type, title, message, onOk,
}) {
  const [visible, setVisible] = useState(false);
  return {
    dialog: (
      <Modal className={visible ? 'visible' : ''}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title || capitalize(type)}</h5>
            </div>
            <ModalBody>
              {message}
            </ModalBody>
            {renderDialogFooter(type, setVisible, onOk)}
          </div>
        </div>
      </Modal>
    ),
    showDialog(v = true) {
      setVisible(v);
    },
  };
}
